import { useCometState } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { useCometGlobalTabsAttachmentsEnabledVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useCometGlobalTabsAttachmentsEnabledVariation.js';
export function useAttachedTabsBadge() {
    const { attachedTabs, actions: { addAttachedTab, removeAttachedTab }, } = useCometState();
    const { variation: isGlobalTabsAttachmentsEnabled } = useCometGlobalTabsAttachmentsEnabledVariation({ defaultValue: false });
    return {
        showAttachedTabsBadge: isGlobalTabsAttachmentsEnabled && attachedTabs.length > 0,
        tabs: attachedTabs,
        onAddTab: addAttachedTab,
        onRemoveTab: removeAttachedTab,
    };
}
//# sourceMappingURL=useAttachedTabsBadge.js.map